export default String.raw`
const graphicalVariantPopup = (() => {
    'use strict';

    let dialogElement = null;
    let variantId = null;
    let variantNameElement = null;

    const init = (container = document) => {
        dialogElement = container.querySelector('.graphical-variant-popup-js');

        if (!dialogElement) {
            return;
        }

        const checkedRadio = dialogElement.querySelector('input[type="radio"]:checked');
        variantId = checkedRadio?.value || null;

        variantNameElement = dialogElement.querySelector('.graphical-variant-name-js');
        if (variantNameElement) {
            variantNameElement.textContent = checkedRadio?.dataset.variant || '';
        }
    };

    init();

    $('body').on('change', '.graphical-variant-popup-js input[type="radio"]', (e) => {
        const radio = e.target;

        if (radio.checked) {
            variantNameElement.textContent = radio.dataset.variant || '';
            variantId = radio.value;
        }
    });

    $('body').on('click', '.open-variants-popup-js', () => {
        dialogElement.showModal();
    });

    $('body').on('click', '.choose-graphical-variant-js', (e) => {
        const checkedRadio = $(e.currentTarget).closest('.graphical-variant-popup-js').find('input[type="radio"]:checked');
        const container = checkedRadio.closest('.attr-graphical-variants-js');
        if ($(e.currentTarget).hasClass('polyvalent-js')) {
            container.find('input[type="radio"][value="' + checkedRadio.val() + '"]').click();
            container.find('.graphical-variant-js.active-js').removeClass('active-js');
            container.find('.graphical-variant-js input[type="radio"][value="' + checkedRadio.val() + '"]').closest('.graphical-variant-js').addClass('active-js');
        } else {
            checkedRadio.closest('.graphical-variant-js').removeClass('prevent-instant-reload-js').click();
        }
    });

    $('body').on('change', '.graphical-variant-js input[type="radio"][name="attributeId"]', (e) => {   
        $(e.currentTarget).closest('.attributes-container-js').find('.graphical-variant-name-js').text($(e.currentTarget).data('variant') || '');
    });

    $('body').on('change click', 'input[type="checkbox"][name="showMore"]', function(e) {
        const checkbox = $(e.currentTarget);
        const count = checkbox.data('count');
        const container = checkbox.closest('.graphical-variants-js');
        const hiddenVariants = container.find('.graphical-variant-js.hidden-js');
        
        if (checkbox.prop('checked')) {
            hiddenVariants.css('opacity', 0)
                .removeClass('hidden-js')
                .animate({ opacity: 1 }, 300);
        } else {
            const visibleVariants = container.find('.graphical-variant-js:not(.hidden-js)');
            const lastVisibleVariants = visibleVariants.slice(-count);
            
            lastVisibleVariants.animate({ opacity: 0 }, 300, function() {
                $(this).addClass('hidden-js').css('opacity', '');
            });
        }
    });

    return {
        init: init,
        getVariantId: () => variantId,
    };
})();
`